import { trackUserEmail } from '@sxm-de/dev-kits/web-sdk/domains/analytics';
import { DependenciesPayload } from '@sxm-de/dev-kits/web-sdk/types';
import {
    logErrorFromClientSdk,
    trackBusinessError,
} from '@sxm-de/dev-kits/web-sdk/utils';

export async function createIdentity(
    {
        emailAddress,
        password,
        language,
    }: {
        emailAddress: string;
        password?: string;
        language?: string;
    },
    dependencies: DependenciesPayload,
): Promise<void> {
    const { clientSdk, appEventSdk } = dependencies;
    try {
        const payload = {
            emailAddress,
            ...(password ? { password } : {}),
            ...(language ? { language } : {}),
        };
        await clientSdk.user.createUserV2(payload);
        trackUserEmail(appEventSdk, emailAddress);
    } catch (error: any) {
        switch (error?.code) {
            case 'userServices.identity.identityAlreadyExists':
            case 'userServices.userSubscriptionOrchestration.eligibilityRequirementsNotMet': {
                trackBusinessError(appEventSdk, error);
                throw new Error('IDENTITY_ALREADY_EXISTS_ERROR');
            }
            case 'userServices.userSubscriptionOrchestration.waitingOnOneTimePassword': {
                if (error?.extras?.identityId) {
                    trackBusinessError(appEventSdk, error);
                    const waitingOnOneTimePasswordError: any = new Error(
                        'WAITING_ON_ONE_TIME_PASSWORD_ERROR',
                    );
                    waitingOnOneTimePasswordError.identityIdToVerifyWithOtpViaEmail =
                        error.extras.identityId;
                    waitingOnOneTimePasswordError.emailAddress =
                        maskEmail(emailAddress);
                    throw waitingOnOneTimePasswordError;
                } else {
                    logErrorFromClientSdk(error, dependencies);
                    throw new Error('SYSTEM');
                }
            }
            case 'userServices.identity.invalidEmail': {
                trackBusinessError(appEventSdk, error);
                throw new Error('INVALID_EMAIL_ERROR');
            }
            case 'userServices.identity.invalidPassword': {
                trackBusinessError(appEventSdk, error);
                throw new Error('INVALID_PASSWORD_ERROR');
            }
            default: {
                logErrorFromClientSdk(error, dependencies);
                throw new Error('SYSTEM');
            }
        }
    }
}

function maskEmail(email: string): string {
    const letterArray = email.split('');
    const emailString = letterArray
        .splice(letterArray.indexOf('@'), letterArray.length)
        .join('');
    return `${letterArray[0]}******${emailString}`;
}
